import "./ReportTypeHeaderSelector.scss";

import type { OptionType } from "components/inputs";
import { Select } from "components/inputs";
import React from "react";

type ReportTypeHeaderSelectorProps = {
  value: OptionType | null;
  onChange: (option: OptionType | null) => void;
  disabled?: boolean;
};

// map of report type values to proper labels
export const REPORT_TYPE_LABELS: Record<string, string> = {
  INVOICE_LIST: "Invoice List",
  BULK_BILLING_REPORT: "Bulk Billing Report",
  REVENUE_BY_CLIENT_REPORT: "Revenue by Client Report",
  BY_SERVICE_REPORT: "By Service Report",
  CLIENT_LIST_REPORT: "Client List",
  EMPTY_FILES_REPORT: "Empty Files Report",
  FILE_LIST: "File List",
  INVOICE_LINE_ITEM_REPORT: "Invoice Line Item Report",
  INVOICE_PAYMENT_REPORT: "Invoice Payment Report",
  NO_SERVICES_REPORT: "No Services Report",
  WORK_IN_PROGRESS: "Work in Progress",
  AI_JOB_BILLING_REPORT: "AI Job Billing Report",
  SECTION_111_INVOICING: "Section 111 Invoicing",
};

export const REPORT_TYPE_OPTIONS: OptionType[] = [
  { label: "Invoice List", value: "INVOICE_LIST" },
  { label: "Bulk Billing Report", value: "BULK_BILLING_REPORT" },
  { label: "Revenue by Client Report", value: "REVENUE_BY_CLIENT_REPORT" },
  { label: "By Service Report", value: "BY_SERVICE_REPORT" },
  { label: "Client List", value: "CLIENT_LIST_REPORT" },
  { label: "Empty Files Report", value: "EMPTY_FILES_REPORT" },
  { label: "File List", value: "FILE_LIST" },
  { label: "Invoice Line Item Report", value: "INVOICE_LINE_ITEM_REPORT" },
  { label: "Invoice Payment Report", value: "INVOICE_PAYMENT_REPORT" },
  { label: "No Services Report", value: "NO_SERVICES_REPORT" },
  { label: "Work in Progress", value: "WORK_IN_PROGRESS" },
  { label: "AI Job Billing Report", value: "AI_JOB_BILLING_REPORT" },
  { label: "Section 111 Invoicing", value: "SECTION_111_INVOICING" },
];

const ReportTypeHeaderSelector: React.FC<ReportTypeHeaderSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <Select
      name="report-type"
      label="Report Type"
      options={REPORT_TYPE_OPTIONS}
      value={value}
      onChange={onChange}
      isDisabled={disabled}
      isClearable={false}
      placeholder="Select Report Type"
      classNames="report-type-header-selector"
      containerClassNames="report-type-header-selector-container"
    />
  );
};

export default ReportTypeHeaderSelector;
